.panel {
	background: var(--surface-card);
	border-radius: var(--radius-lg);
	padding: var(--space-5);
	display: flex;
	flex-direction: column;
	gap: var(--space-4);
}

.headerRow {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: var(--space-3);
}

.heading {
	margin: 0;
	font-size: 1rem;
	font-weight: 600;
	color: var(--ink-muted);
	text-transform: uppercase;
	letter-spacing: 0.04em;
}

.clear {
	background: none;
	border: none;
	color: var(--accent-rose);
	font: inherit;
	font-size: 0.85rem;
	cursor: pointer;
	padding: 0;
}

.clear:disabled {
	opacity: 0.4;
	cursor: not-allowed;
}

.value {
	margin: 0;
	font-size: 1.0625rem;
	font-weight: 600;
	color: var(--ink);
}

/* Hand-rolled range styling so the track/thumb match the sage palette
   rather than the grey UA default. */
.slider {
	width: 100%;
	appearance: none;
	-webkit-appearance: none;
	height: 6px;
	border-radius: 999px;
	background: var(--surface-input);
	border: 1px solid var(--border);
	cursor: pointer;
	margin: 0;
}

.slider::-webkit-slider-thumb {
	appearance: none;
	-webkit-appearance: none;
	width: 22px;
	height: 22px;
	border-radius: 50%;
	background: var(--accent-sage);
	border: 2px solid var(--surface-card);
	box-shadow: var(--shadow-card);
	cursor: pointer;
}

.slider::-moz-range-thumb {
	width: 22px;
	height: 22px;
	border-radius: 50%;
	background: var(--accent-sage);
	border: 2px solid var(--surface-card);
	box-shadow: var(--shadow-card);
	cursor: pointer;
}

.ticks {
	display: flex;
	justify-content: space-between;
	margin-top: calc(-1 * var(--space-2));
}

.tick {
	font-size: 0.75rem;
	color: var(--ink-muted);
	font-variant-numeric: tabular-nums;
}

.note {
	margin: 0;
	font-size: 0.8rem;
	color: var(--ink-muted);
}

.actions {
	display: flex;
	justify-content: flex-end;
}

.done {
	padding: var(--space-2) var(--space-4);
	background: var(--accent-sage);
	border: none;
	border-radius: var(--radius-md);
	color: #fff;
	font: inherit;
	font-weight: 600;
	cursor: pointer;
}
